import { render, staticRenderFns } from "./HeartCheckbox.vue?vue&type=template&id=6ae9c5b8"
import script from "./HeartCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./HeartCheckbox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports